<div class="table">
  <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" multiTemplateDataRows [trackBy]="trackElement" aria-label="Seepex Generic Table" aria-labelledby="Seepex">
    <ng-content></ng-content>

    <ng-container *ngFor="let col of tableConfig?.columns" [matColumnDef]="col.id">
      <ng-container *ngIf="col.sort; else defaultHeaderCell">
        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{ col.headerText | translate }}</th>
      </ng-container>
      <ng-template #defaultHeaderCell>
        <th scope="col" mat-header-cell *matHeaderCellDef>{{ col.headerText | translate }}</th>
      </ng-template>
      <td mat-cell *matCellDef="let element">{{ element[col.id] }}</td>
    </ng-container>

    <ng-container *ngIf="tableConfig?.row.expandable" matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="tableConfig?.row.colCount">
        <div class="table__detail-row__content" [@detailExpand]="element && expandedElement && element.Id === expandedElement.Id ? 'expanded' : 'collapsed'">
          <ng-container *ngTemplateOutlet="detailTemplate; context: { data: element }"></ng-container>
          <ng-template #noContent> Please provide detail template to style your own detail view </ng-template>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="tableDisplayColumns; sticky: tableConfig?.row.sticky"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: tableDisplayColumns"
      class="table__row"
      [ngClass]="{ 'table__row--expanded': row && expandedElement ? row.Id === row.Id : false, table__row__expandable: tableConfig?.row.expandable }"
      (click)="toggleRow(row)"></tr>
    <ng-container *ngIf="tableConfig?.row.expandable">
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table__detail-row"></tr>
    </ng-container>

    <tr class="mat-row table__row__no-data" *matNoDataRow>
      <ng-container *ngIf="isLoading; else nodata">
        <spx-spinner [overlay]="true" [size]="'SMALL'"></spx-spinner>
      </ng-container>
      <ng-template #nodata>
        <td class="mat-cell">No data</td>
      </ng-template>
    </tr>
  </table>
</div>
